var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"bar-button",class:{ active: _vm.active },on:{"touchstart":_vm.onTouchStart,"click":function($event){return _vm.$emit('click', _vm.utility)}}},[_c('i',{class:_vm.iconClass})])])}
var staticRenderFns = []

export { render, staticRenderFns }